// Screens nobody sits at: the floor TV (/monitor) and the clock kiosk opened
// from the Clock tile (/clock-face). Used by ConsentGate (no Terms
// prompt). UpdateBanner withholds its card on /monitor only. Exact paths.
export const FLOOR_MONITOR_PATH = '/monitor'
export const UNATTENDED_DISPLAY_PATHS: ReadonlySet<string> = new Set([FLOOR_MONITOR_PATH, '/clock-face'])
